
.sidebar-page
  section.sidebar-layout
    b-sidebar(
      type="is-light"
      :fullheight="fullheight"
      :fullwidth="fullwidth"
      :overlay="overlay"
      :right="right"
      :open.sync="open")

      .all-stuff
        .block
          a(href="/")
            img.vsp-logo(
              src="@/assets/images/vsp-logo-left.png"
              alt="TU Berlin VSP Department")

        b-menu-list(label="Login Required")

        p.my-label {{ whichLogin }}: access to this site requires a login.

        b-menu-list(label="Username")
        b-input(v-model="username" placeholder="VSP username" maxlength=30)

        b-menu-list(label="Password")
        b-input(type="password"
          v-model="password"
          password-reveal)

        b-button.my-space.is-primary(
          @click="clickedLogin"
          :disabled="!username || !password") Login

